<template>
    <footer class="footer">
        <div class="content has-text-centered">
            <p class="pa-0 ma-0">
                © <a :href="$t('lending_url')">{{$t('lending_name')}}</a> {{$t('footer_text')}}
            </p>
            <p v-if="settings.contact_email" class="pa-0 ma-0">
                {{$t('communication_email')}} -
                <a :href="'mailto:' + settings.contact_email" target="_top">{{settings.contact_email}}</a>
            </p>
        </div>
    </footer>
</template>

<script>
    import settings from "@/environment";

    export default {
        name: 'Footer',
        data() {
            return { settings }
        }
    };
</script>

<style>
    .footer {
        background-color: #ffffff;
        border-top: solid 1px #e4e4e4;
    }
</style>
